import { useState } from "react";
import { Ban, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function BlockButton({ p, onChanged, className }) {
  const [busy, setBusy] = useState(false);
  const [ask, setAsk] = useState(false);
  if (p.is_me || p.is_creator || p.is_moderator) return null;
  const toggle = async () => {
    setAsk(false);
    setBusy(true);
    try {
      if (p.blocked_by_me) await api.delete(`/users/${p.user_id}/block`); else await api.post(`/users/${p.user_id}/block`);
      toast.success(p.blocked_by_me ? "Blockierung aufgehoben" : `${p.name} wurde blockiert`);
      onChanged?.();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <>
    <AlertDialog open={ask} onOpenChange={setAsk}>
      <AlertDialogContent className="rounded-3xl" data-testid="block-confirm-dialog">
        <AlertDialogTitle>{p.name} blockieren?</AlertDialogTitle>
        <AlertDialogDescription>Ihr seht dann keine Beiträge, Kommentare und Nachrichten mehr voneinander, und eure Freundschaft wird beendet. Du kannst das jederzeit in deinem Profil rückgängig machen.</AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full" data-testid="block-confirm-cancel">Abbrechen</AlertDialogCancel>
          <AlertDialogAction onClick={toggle} className="rounded-full bg-red-600 hover:bg-red-700" data-testid="block-confirm-ok">Blockieren</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    <button onClick={() => (p.blocked_by_me ? toggle() : setAsk(true))} disabled={busy} data-testid={p.blocked_by_me ? "unblock-user-btn" : "block-user-btn"} title={p.blocked_by_me ? "Blockierung aufheben" : "Blockieren"}
      className={`${className} ${p.blocked_by_me ? "bg-red-50 text-red-600 hover:bg-red-100" : "bg-slate-100 hover:bg-slate-200 text-slate-600"}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Ban className="w-4 h-4" />} <span className={p.blocked_by_me ? "" : "hidden sm:inline"}>{p.blocked_by_me ? "Blockierung aufheben" : "Blockieren"}</span>
    </button>
    </>
  );
}
